var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editDataLocal",
              staticClass: "demo-dynamic",
              attrs: { model: _vm.editDataLocal, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "打印机选择：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editDataLocal.op,
                        callback: function ($$v) {
                          _vm.$set(_vm.editDataLocal, "op", $$v)
                        },
                        expression: "editDataLocal.op",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("通用打印机(仅支持单张打印)"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("快递100打印机(支持批量打印)"),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "line-heightOne from-tips" }, [
                    _vm._v(
                      "通用打印机不限型号，在电脑浏览器界面右上角选择打印机并设置即可; 快送100电子面单打印机型号:快送100云打印机二代3寸 电脑Wi-Fi两用"
                    ),
                  ]),
                ],
                1
              ),
              _vm.editDataLocal.op === 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "云打印机编号：",
                            prop: "cloudPrintNo",
                            rules: {
                              required: true,
                              message: "云打印机编号",
                              trigger: "blur",
                            },
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "云打印机编号" },
                            model: {
                              value: _vm.editDataLocal.cloudPrintNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDataLocal, "cloudPrintNo", $$v)
                              },
                              expression: "editDataLocal.cloudPrintNo",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "line-heightOne from-tips" },
                            [
                              _vm._v(
                                "快递100电子面单打印机编号,在打印机背面查看"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发货地址：",
                    prop: "senderAddr",
                    rules: {
                      required: true,
                      message: "发货地址",
                      trigger: "blur",
                    },
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "发货地址" },
                    model: {
                      value: _vm.editDataLocal.senderAddr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editDataLocal, "senderAddr", $$v)
                      },
                      expression: "editDataLocal.senderAddr",
                    },
                  }),
                  _c("div", { staticClass: "line-heightOne from-tips" }, [
                    _vm._v("电子面单默认发货地址"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "寄件人姓名：",
                    prop: "senderUsername",
                    rules: {
                      required: true,
                      message: "寄件人姓名",
                      trigger: "blur",
                    },
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "寄件人姓名" },
                    model: {
                      value: _vm.editDataLocal.senderUsername,
                      callback: function ($$v) {
                        _vm.$set(_vm.editDataLocal, "senderUsername", $$v)
                      },
                      expression: "editDataLocal.senderUsername",
                    },
                  }),
                  _c("div", { staticClass: "line-heightOne from-tips" }, [
                    _vm._v("电子面单默认寄件人姓名"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "寄件人电话：",
                    prop: "senderPhone",
                    rules: {
                      required: true,
                      validator: _vm.validatePhone,
                      message: "电话号码不正确",
                      trigger: "blur",
                    },
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "寄件人电话" },
                    model: {
                      value: _vm.editDataLocal.senderPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.editDataLocal, "senderPhone", $$v)
                      },
                      expression: "editDataLocal.senderPhone",
                    },
                  }),
                  _c("div", { staticClass: "line-heightOne from-tips" }, [
                    _vm._v("电子面单默认寄件人电话"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitClickUp("editDataLocal")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }